import { render } from "./phbsm.vue?vue&type=template&id=46807754&scoped=true"
import script from "./phbsm.vue?vue&type=script&lang=js"
export * from "./phbsm.vue?vue&type=script&lang=js"

import "./phbsm.vue?vue&type=style&index=0&id=46807754&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46807754"]])

export default __exports__